import React, { useState } from "react"
import { useForm } from "react-hook-form"
import classNames from "classnames"
import axios from "axios"
import styled from "styled-components"
import tw from "tailwind.macro"

import bgImage from "../images/backimage-leaf.svg"

const FormSection = styled.section`
  .form-inner {
    background-color: #e8e8e8;
    background-image: url(${bgImage});
    ${tw`bg-center bg-no-repeat bg-cover`}
  }
`

const FormContainer = styled.div`
  ${tw`flex flex-col max-w-lg mx-auto px-18 md:px-40 xl:px-50 py-50 md:py-32 lg:py-40 xl:pt-80 xl:pb-88 flex-wrap`}

  .status-failed {
    border: 1px solid #ff8484;
    background-color: #fff4f4;
    color: #ff0000;
    ${tw`font-medium text-center mt-18 py-5 mx-4`}
  }

  .status-sent {
    ${tw`font-medium text-secondary-success text-center py-5 mt-18`}
    border: 1px solid #0AA54A;
  }
`

const FormGroupRow = styled.div`
  ${tw`w-full md:flex`}
`

const FormGroup = styled.div`
  ${tw`flex flex-col items-center text-base mb-20 md:text-lg md:mx-5 lg:text-xl xl:mb-16`}

  input.error {
    border: 2px solid #ff0000;
  }

  textarea {
    ${tw`outline-none whitespace-no-wrap overflow-hidden resize-none`}
    min-height: 200px;
  }
`

const FormGroupButton = styled.div`
  ${tw`flex flex-col items-start text-base md:text-lg lg:text-xl my-4 `}
`

const FormError = styled.div`
  ${tw`block text-base text-white w-full rounded-md px-3 py-1 text-sm rounded-t-none font-medium`}
  background-color: #ff0000;
`

const Form = ({ className }) => {
  const { handleSubmit, register, errors } = useForm()
  const [loading, setLoading] = useState(false)
  const [status, setStatus] = useState()
  const contactFormId = "2603"
  const onSubmit = async (values, e) => {
    try {
      setLoading(true)
      const formData = new FormData()
      formData.append("full-name", values.name)
      formData.append("country", values.country)
      formData.append("contact-number", values.number)
      formData.append("email", values.email)
      formData.append("reason", values.reason)
      formData.append("detail", values.detail)
      formData.append("_wpcf7_unit_tag", "form_contact_page")
      const { data } = await axios.post(
        `${process.env.SOURCE_URL}/wp-json/contact-form-7/v1/contact-forms/${contactFormId}/feedback/`,
        formData
      )
      setStatus({
        type: data.status.split("_")[1],
        message: data.message,
			})

			e.target.reset();
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <FormSection
      id="contact"
      className={classNames("section-gap-sm xl:section-gap-xl", className)}
    >
      <div className="form-inner">
        <FormContainer>
          <h2 className="font-fb xs:h2-sm lg:h2-lg text-center mb-2">
            Contact us
          </h2>
          <div className="sm:w-11/12 md:w-4/6 lg:w-6/12 block mx-auto">
            <p className="text-center font-medium">
              Speak directly with our directors, fill out below details and we
              will get back to you.
            </p>
          </div>
          {status && (
            <div className={`status-${status.type}`}>{status.message}</div>
          )}
          <form
            className="w-full flex flex-wrap mt-18"
            onSubmit={handleSubmit(onSubmit)}
          >
            <FormGroupRow>
              <FormGroup className="form-group w-full  md:w-2/4">
                <input
                  className={classNames(
                    "input-text form-feild-fz placeholder-grey-dark",
                    { error: errors.name }
                  )}
                  type="text"
                  ref={register({
                    required: true,
                    pattern: {
                      value: /.*\S.*/i,
                      message: "Invalid full name",
                    },
                  })}
                  placeholder="Full name*"
                  name="name"
                />
                {errors.name && <FormError>This field is required</FormError>}
              </FormGroup>
              <FormGroup className="form-group w-full  md:w-2/4">
                <input
                  className="input-text form-feild-fz placeholder-grey-dark"
                  type="text"
                  ref={register}
                  placeholder="Based Country"
                  name="country"
                />
              </FormGroup>
            </FormGroupRow>
            <FormGroupRow>
              <FormGroup className="form-group w-full  md:w-2/4">
                <input
                  className="input-text form-feild-fz placeholder-grey-dark"
                  type="number"
                  ref={register}
                  placeholder="Contact Number"
                  name="number"
                />
              </FormGroup>
              <FormGroup className="form-group w-full  md:w-2/4">
                <input
                  className={classNames(
                    "input-text form-feild-fz placeholder-grey-dark",
                    { error: errors.email }
                  )}
                  type="email"
                  ref={register({
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Invalid email address",
                    },
                  })}
                  placeholder="Email address*"
                  name="email"
                />
                {errors.email && (
                <FormError>
                  {errors.email.message
                    ? errors.email.message
                    : "This field is required"}
                </FormError>
              )}
              </FormGroup>
            </FormGroupRow>
            <FormGroup className="form-group w-full">
              <input
                className={classNames(
                  "input-text form-feild-fz placeholder-grey-dark",
                  { error: errors.reason }
                )}
                type="text"
                ref={register({
                  required: true,
                  pattern: {
                    value: /.*\S.*/i,
                    message: "Invalid reason of contact",
                  },
                })}
                placeholder="Reason of contact*"
                name="reason"
              />
              {errors.reason && <FormError>This field is required</FormError>}
            </FormGroup>
            <FormGroup className="form-group w-full">
              <textarea
                className="input-text form-feild-fz placeholder-grey-dark"
                type="text"
                placeholder="Describe in detail"
                name="detail"
                ref={register}
                pattern="^\S+$"
              ></textarea>
            </FormGroup>

            <FormGroupButton className="form-group w-full items-start">
              <button
                type="submit"
                className="btn sm:btn-sm w-full text-base md:mx-5"
                disabled={loading}
              >
                CONTACT US
              </button>
            </FormGroupButton>
          </form>
        </FormContainer>
      </div>
    </FormSection>
  )
}

export default Form
